import React from "react";
import {RequestOverviewRowDTO, RequestFilter} from "@/api/data-contracts";
import {RequestStatusBadge} from "@/common/RequestStatusBadge";
import {QuoteStatusBadge} from "@/common/QuoteStatusBadge";

export interface RequestStatusCellProps {
    row: RequestOverviewRowDTO;
    type: RequestFilter;
}

/**
 * Renders the status badge cell for the request overview table.
 * Shows RequestStatusBadge for internal requests and QuoteStatusBadge for external.
 */
export const RequestStatusCell: React.FC<RequestStatusCellProps> = ({row, type}) => {
    if (type === RequestFilter.INTERNAL) {
        return (
            <RequestStatusBadge
                status={row.requestStatus}
                count={row.submittedQuoteCount}
                fullWidth
            />
        );
    }
    return <QuoteStatusBadge status={row.quoteStatus} fullWidth/>;
};
